.checkboxesContainer {
    display: flex;
    flex-wrap: wrap;
}

.checkboxContainer {
    margin: 0px;
    display: flex;
    align-items: center;
    width: 100%;
}

.container {
    position: relative;
}